import { render, staticRenderFns } from "./ProHintModal.vue?vue&type=template&id=00a258ee"
import script from "./ProHintModal.vue?vue&type=script&lang=ts"
export * from "./ProHintModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports